import React from 'react';
import Box from '@mui/material/Box';

import Container from './Container';
import Head from './Head';
import HeadCell from './HeadCell';
import Row from './Row';
import Cell from './Cell';
import Placeholder from './Placeholder';

interface Props {
  children: React.ReactNode;
}

const NestedTable = ({ children }: Props) => {
  return <Container>{children}</Container>;
};

NestedTable.Head = Head;
NestedTable.HeadCell = HeadCell;
NestedTable.Body = Box;
NestedTable.Row = Row;
NestedTable.Cell = Cell;
NestedTable.Placeholder = Placeholder;

export default NestedTable;
